import apiClient from "./apiClient";
import { DirectionResponse, QuestionPageResponse, QuestionResponse, TagResponse } from "../../types/types";
import { API_ENDPOINTS } from "../../utils/config/constants";

export type QuestionsQuery = {
  directionId?: number | null;
  tagId?: number | null;
  search?: string | null;
  page?: number;
  size?: number;
  sort?: string;
};

const appendDefined = (params: URLSearchParams, key: string, value: string | number | null | undefined) => {
  if (value !== null && value !== undefined && String(value).trim() !== "") {
    params.set(key, String(value));
  }
};

export const QuestionsApi = {
  getDirections: async () => {
    const response = await apiClient.get<DirectionResponse[]>(API_ENDPOINTS.DIRECTIONS);
    return response.data;
  },

  getDirectionTags: async (directionId: number) => {
    const response = await apiClient.get<TagResponse[]>(`${API_ENDPOINTS.DIRECTIONS}/${directionId}/tags`);
    return response.data;
  },

  getQuestions: async (query: QuestionsQuery) => {
    const params = new URLSearchParams();
    appendDefined(params, "directionId", query.directionId);
    appendDefined(params, "tagId", query.tagId);
    appendDefined(params, "search", query.search);
    appendDefined(params, "page", query.page ?? 0);
    appendDefined(params, "size", query.size ?? 50);
    appendDefined(params, "sort", query.sort ?? "title,asc");

    const response = await apiClient.get<QuestionPageResponse>(`${API_ENDPOINTS.QUESTIONS}?${params.toString()}`);
    return response.data;
  },

  getQuestion: async (id: number) => {
    const response = await apiClient.get<QuestionResponse>(`${API_ENDPOINTS.QUESTIONS}/${id}`);
    return response.data;
  },
};
